export default function PHP_gettimeofday() {
  return (
    <div>
      <h1>PHP_gettimeofday</h1>
    </div>
  );
}
